import React, { Component } from 'react';
import './_styles.scss';

class SuperhighlightAddOn extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="superhighlight-add-on">
				<img className="superhighlight-add-on__img" src={this.props.image} alt="Superhighlight Add-On" />
			</div>
		);
	}
}

export default SuperhighlightAddOn;



// WEBPACK FOOTER //
// ./src/payments/DetailSelector/LandingComercialAddOn/Components/SuperhighlightAddOn/index.jsx